// ============================================================
//  src/utils/helpers.js
// ============================================================

/** Format amount as Naira string. */
export const formatNaira = (amount, showSymbol = true) => {
  const num = parseFloat(amount) || 0;
  const formatted = num.toLocaleString('en-NG', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return showSymbol ? `₦${formatted}` : formatted;
};

/** Format a date string to "12 Jan 2025" or "12 Jan 2025, 2:30 PM" */
export const formatDate = (dateStr, includeTime = false) => {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr;
  const opts = { day: 'numeric', month: 'short', year: 'numeric' };
  if (includeTime) {
    opts.hour = '2-digit';
    opts.minute = '2-digit';
    opts.hour12 = true;
  }
  return d.toLocaleDateString('en-GB', opts);
};

/** Relative time: "just now", "3m ago", "2h ago", "4d ago" */
export const timeAgo = (dateStr) => {
  if (!dateStr) return '';
  const diff = Math.floor((Date.now() - new Date(dateStr)) / 1000);
  if (diff < 60)       return 'just now';
  if (diff < 3600)     return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400)    return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800)   return `${Math.floor(diff / 86400)}d ago`;
  return formatDate(dateStr);
};

/** Extract a human-readable error message from an axios error. */
export const getError = (err) =>
  err?.response?.data?.msg ||
  err?.response?.data?.message ||
  err?.message ||
  'Something went wrong.';

/** Truncate a string to max chars with ellipsis. */
export const truncate = (str, max = 40) => {
  if (!str) return '';
  return str.length > max ? str.slice(0, max) + '…' : str;
};

/** Generate a unique transaction reference. */
export const genRef = () =>
  `TXN-${Date.now()}-${Math.random().toString(36).slice(2, 7).toUpperCase()}`;

/** Map transaction status code to label + color. */
export const txStatusMap = {
  0: { label: 'Success',    badge: 'badge-success' },
  1: { label: 'Failed',     badge: 'badge-danger'  },
  2: { label: 'Pending',    badge: 'badge-warning'  },
  5: { label: 'Processing', badge: 'badge-warning'  },
};

export const getTxStatus = (code) =>
  txStatusMap[parseInt(code)] || { label: 'Unknown', badge: 'badge-muted' };

/** Nigerian states list. */
export const NIGERIAN_STATES = [
  'Abia','Adamawa','Akwa Ibom','Anambra','Bauchi','Bayelsa','Benue','Borno',
  'Cross River','Delta','Ebonyi','Edo','Ekiti','Enugu','FCT','Gombe','Imo',
  'Jigawa','Kaduna','Kano','Katsina','Kebbi','Kogi','Kwara','Lagos','Nasarawa',
  'Niger','Ogun','Ondo','Osun','Oyo','Plateau','Rivers','Sokoto','Taraba',
  'Yobe','Zamfara',
];

/** Mask email for display: u***@gmail.com */
export const maskEmail = (email = '') => {
  const [local, domain] = email.split('@');
  if (!domain) return email;
  return `${local[0]}***@${domain}`;
};
